import PageProtectedLayout from "../../components/Page/PageProtectedLayout";
import WelcomePage from "./WelcomePage";
import { useTranslation } from '../../language';

export default function WelcomepageRoot() {
  const { t } = useTranslation();

  return (
    <PageProtectedLayout
      headline={t('page_hl_welcome')}
      specify={t('page_sp_more_healthy_years')}
      headlineMb={ {xs: 0, sm: 0 }}
    >
      <WelcomePage />
    </PageProtectedLayout>
  );
}
